import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-details-section',
  templateUrl: './item-details-section.component.html',
  styleUrls: ['./item-details-section.component.scss']
})
export class ItemDetailsSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
